module.exports = __webpack_public_path__ + "static/pic06.88498ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic06.jpg
// module id = 516
// module chunks = 263791100135453